import "../../assets/Layout.scss";

import { Alert, Avatar, FloatButton } from 'antd';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { useState } from 'react';

import ButtonRdv from '../ButtonRdv';
import CallModal from '../CallModal';
import { PhoneOutlined } from '@ant-design/icons';
import { isNowOpen } from '../../utils/getWorkingHours';

export default function Layout() {
    const [callModalOpen, setCallModalOpen] = useState(false);

    return (
        <>
            <CallModal open={callModalOpen} onClose={() => setCallModalOpen(false)} />

            {isNowOpen() &&
                <FloatButton
                    tooltip="Appeler un médecin"
                    icon={<PhoneOutlined />}
                    onClick={() => setCallModalOpen(true)}
                />
            }
            {new Date() < new Date(2026, 4, 19) && <Alert
                banner
                type="info"
                message="Congé de maternité — Retour le 19 mai"
                description={
                    <span>
                        Le Dr Boulanger est en congé de maternité et reprend le <strong>19 mai</strong>. Elle sera alors joignable du <strong>lundi au vendredi de 8h à 18h</strong>, sauf le <strong>mercredi</strong> et le <strong>vendredi</strong>.
                        <br />
                        En attendant, sa remplaçante <strong>Dr Sarah Mejani</strong>, Médecin Généraliste et diplômée en nutrition, assure les consultations.
                        Elle est joignable au <strong>0470 50 08 90</strong> et via la plateforme{' '}
                        <a href="https://rosa.be/fr/hp/sarah-mejani/" target="_blank" rel="noopener noreferrer">Rosa</a>.
                    </span>
                }
                showIcon
            />}
            <header className="headerApp">

                <Avatar size={56} src={<img src={"./doctor.png"} alt="Dr. Elisabeth Boulanger" />} />
                <h1 style={{ flex: 1 }}>
                    <Link to="/">
                        Docteur Elisabeth Boulanger<br />
                        <small>Médecine Générale, agréé et accrédité</small>
                    </Link>
                </h1>
                <ButtonRdv type="default" />

            </header>
            <main>
                <Outlet />

            </main>
            <footer className="footerApp">
                <div className="footerContent">

                    <p>
                        <strong>Docteur Boulanger</strong><br />
                        Médecine générale<br />
                        Rue Hélène de Visscher 1, 5004 Bouge<br />
                        +32 492 66 66 67
                    </p>

                    <iframe
                        title='Google Maps'
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1269.5650831932924!2d4.888572799930575!3d50.475920427790825!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c199a8107a98c5%3A0x77e614b05048e391!2sDocteur%20Elisabeth%20Boulanger!5e0!3m2!1sfr!2sbe!4v1722865628505!5m2!1sfr!2sbe"
                        width="280"
                        height="180"
                        style={{ border: 0, borderRadius: 12, display: 'block' }}
                        allowFullScreen={false}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <NavLink to="/privacy">Politique de confidentialité</NavLink>
            </footer>
        </>
    )
}
